var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02Ai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 66",
    enableBackground: "new 0 0 54 66",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "52.6,63.9 3.8,63.9 3.8,2.1 37.8,2.1 52.6,17.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M53.1,64.4H3.3V1.6h34.8l15.1,15.9V64.4z M4.3,63.3H52V18L37.6,2.7H4.3V63.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M53,64.4H3.1V1.6h35.2L53,16.4V64.4z M4.2,63.3h47.7V16.9l-14-14.2H4.2V63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M40.2,22.6l-3.1,3.9l-5.7-7.3c0,0-3.9,6.6-5.9,9.9c-1.1-0.4-2.2-0.7-3.4-0.7c-5,0-9,3.9-9.3,8.8l0,0h0 c0,0,0,0,0,0.1h18.7c0,0,0,0,0-0.1h12.1L40.2,22.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBCBCB",
    cx: 19.8,
    cy: 17.9,
    r: 4.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C5C5C5",
    points: "38.1,2.1 38.1,16.7 52.4,16.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.7,
    y: 42.5,
    fill: "#D68A46",
    width: 48.8,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D68A46",
    d: "M53,64.4H3.1V42H53V64.4z M4.2,63.3h47.7V43.1H4.2V63.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.5,57.3l-1.2-2.9h-3.7l-1.1,2.9h-1.1l3.7-9.3H27l3.6,9.3H29.5z M28,53.3l-1.1-2.9 c-0.1-0.4-0.3-0.8-0.4-1.3c-0.1,0.4-0.2,0.8-0.4,1.3L25,53.3H28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.6,57.3V48h1.1v9.2H31.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Ai);
export default __webpack_public_path__ + "static/media/02-ai.7a215f4a2cf3172350517e7f67cd57e4.svg";
export { ForwardRef as ReactComponent };